<template>
  <div>
    <el-button-group>
      <slot name="s1"></slot>
      <el-button type="primary" v-for="btn in authBtns" :key="btn.code" @click.native="btnClick(btn.code)" size="small">{{btn.name}}
      </el-button>
      <slot name="s2"></slot>
    </el-button-group>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    props: {
      authBtns: []
    },
    data () {
      return {
      }
    },
    created () {
    },
    components: {},
    methods: {
      btnClick (code) {
        this.$emit('click', code)
      }
    },
    computed: {
      ...mapState({})
    }
  }
</script>

<style scoped>
</style>
